<template>
  <asd20-app-template
    :tabs="tabs"
    :sidebar-icon="desktop ? '' : 'list'"
    :sidebar-badge="totalFiltersApplied"
    :sidebar-title="
      $route.name.includes('team') ? 'Select a Team: ' : 'Job Types: '
    "
    searchable
    search-placeholder="Search"
    :keywords.sync="keywords"
    title="Directory"
    icon="directory"
    :version="version"
    :back-link="referrer"
    :back-label="referrer.replace(/https?:\/\//, '')"
  >
    <template v-slot:toolbar-start>
      <asd20-select-input
        v-if="selectedOrganizationId"
        v-model="selectedOrganizationId"
        :items="organizations"
        item-label="title"
        item-value="id"
      >
        <template #prefix>
          <img
            class="school-logo"
            :src="selectedOrganization.logoImageUrl"
            alt="School logo"
            style="width: auto; height: 2em; margin-left: 1rem;"
          />
        </template>
      </asd20-select-input>
    </template>
    <template #sidebar-title>
      <!-- <asd20-button
        id="clear-button"
        v-if="totalFiltersApplied"
        transparent
        horizontal
        size="sm"
        icon="danger"
        label="Clear Selections"
        @click.native="clearFilters"
      /> -->
    </template>
    <template #sidebar>
      <asd20-people-filters v-if="$route.name === 'people'" />
      <asd20-teams-filters v-if="$route.name.includes('team')" />
    </template>

    <template>
      <div class="page-wrapper">
        <transition :name="pageTransition">
          <router-view v-if="selectedOrganizationId"></router-view>
        </transition>
      </div>
    </template>
  </asd20-app-template>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import { version } from '../../package.json'
import debounce from 'lodash/debounce'
import Asd20AppTemplate from '@asd20/ui/src/components/templates/Asd20AppTemplate'
import Asd20PeopleFilters from '../components/organisms/Asd20PeopleFilters'
import Asd20TeamsFilters from '../components/organisms/Asd20TeamsFilters'
import Asd20SelectInput from '@asd20/ui/src/components/atoms/Asd20SelectInput'

export default {
  name: 'Asd20DirectorySearchPage',
  components: {
    Asd20AppTemplate,
    Asd20PeopleFilters,
    Asd20TeamsFilters,
    Asd20SelectInput,
  },

  props: {
    abbreviation: { type: String },
  },

  data: () => ({
    pageTransition: 'fade',
    version,
    locationsModalOpen: false,
    selectedLocations: [],
    desktop: false,
    zoomed: false,
    teamsTab: true,
  }),

  computed: {
    keywords: sync('keywords'),
    filteredGroupsCount: get('groups/filteredGroupsCount'),
    filteredPeopleCount: get('people/filteredPeopleCount'),
    searchPayload: get('people/searchPayload'),
    totalFiltersApplied: get('people/totalFiltersApplied'),
    organizations: get('organizations'),
    organizationOptions: get('organizationOptions'),
    selectedOrganizationId: sync('selectedOrganizationId'),
    selectedOrganization: get('selectedOrganization'),
    referrer: get('referrer'),
    tabs() {
      return [
        {
          label: 'Teams',
          badge: Number(this.filteredGroupsCount),
          to: `/${this.$route.params.abbreviation}/teams`,
          active: this.$route.path.includes('/teams'),
        },
        {
          label: 'People',
          badge: Number(this.filteredPeopleCount),
          to: `/${this.$route.params.abbreviation}/people`,
          active: this.$route.path.includes('/people'),
        },
      ]
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.teamsTab = this.$route.path.includes('/teams')
      this.pageTransition =
        toDepth < fromDepth ? 'out' : toDepth === fromDepth ? 'fade' : 'in'
    },
    searchPayload: {
      handler: async function() {
        await this.queryPeople()
      },
    },
  },

  beforeRouteEnter(from, to, next) {
    next(vm => {
      vm.fetchData()
    })
  },

  // beforeUpdate() {
  //   this.fetchData()
  // },

  // created() {
  //   if (Object.keys(this.$route.query).length === 0) {
  //     this.queryPeople()
  //   }
  // },
  mounted() {
    this.desktop = window.innerWidth >= 1250
    this.zoomed = window.innerHeight <= 500
    window.addEventListener('resize', this.handleResize)
  },

  methods: {
    queryPeople: debounce(function() {
      this.$store.dispatch('people/queryPeople')
    }, 500),
    clearFilters() {
      this.$store.dispatch('people/clearFilters')
    },
    async fetchData() {
      this.$store.dispatch('people/getFilters')
      await this.$store.dispatch('getOrganizations')
      await this.$store.dispatch('groups/getGroups')
      if (!this.selectedOrganizationId && this.organizations.length) {
        const abbreviation = this.$route.params.abbreviation
        let orgId = this.organizations[0].id // Default
        if (abbreviation) {
          const org = this.organizations.find(
            o => o.abbreviation.toLowerCase() === abbreviation
          )
          if (org) orgId = org.id
        }
        this.selectedOrganizationId = orgId
      }

      this.queryPeople()
    },
    handleResize() {
      this.desktop = window.innerWidth >= 1250
      this.zoomed = window.innerHeight <= 500
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';

// $anim-base-speed: 2s !global;
.asd20-app-template {
  .asd20-app-header {
    border: none;
  }
  .asd20-select-input {
    margin: space(0.25) 0;
    --fill-color: transparent !important;
    label {
      font-size: 1.25em;
      height: 3rem;
    }
  }

  .asd20-app-template__main {
    overflow-y: auto;
  }
  .asd20-app-template__toolbar {
    .asd20-button {
      padding: 0.6rem;
      border: 2px solid var(--color__primary);
      height: 2.75rem;
      .asd20-badge {
        top: -0.5rem;
        right: 0;
      }
    }
    .asd20-button__label {
      display: block !important;
    }
    .asd20-search-field {
      width: 50vw;
      border: 2px solid gray;
      input {
        background: var(--color__accent-t90);
      }
    }
    .asd20-select-input__field-wrapper {
      justify-content: flex-start;
      label {
        font-family: var(--website-typography__font-family-headlines);
        font-weight: bold;
      }
    }
    .asd20-select-input__select-wrapper {
      flex-grow: 0;
    }
  }
  .asd20-accordion__header {
    display: none;
  }

  .asd20-app-template__toolbar-zoomed {
    .asd20-search-field {
      border-top: none;
    }
  }
}
#clear-button {
  display: none;
  margin-left: 0;
}
@media (min-width: 667px) {
  .asd20-app-template {
    .asd20-app-template__toolbar {
      flex-wrap: nowrap !important;
      margin-right: 1rem;
      .asd20-select-input {
        border-bottom: none;
      }
      .asd20-search-field {
        width: 50vw;
      }
      .asd20-button {
        .asd20-badge {
          top: -0.5rem;
          right: -0.75rem;
        }
      }
    }
  }
}

@media (min-width: 1024px) {
  .asd20-app-template {
    #clear-button {
      display: inherit;
      margin-left: auto;
    }
    &__sidebar {
      border-right: 3px solid var(--color__tertiary) !important;
    }
    &__sidebar h2 {
      border-bottom: 3px solid var(--color__tertiary);
    }
    .asd20-app-template__toolbar {
      .asd20-search-field {
        width: 50vw;
        // border-top: none;
        // border-left: 1px solid var(--color__tertiary);
      }
    }
  }

  .asd20-select-input {
    width: inherit;
    flex-grow: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  position: absolute;
  width: 100%;
  transition: all asd20-speed(1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.squish-enter-active,
.squish-leave-active {
  position: relative;
  transition: all asd20-speed(1) $anim-easing;
  z-index: -10;
}

.squish-enter {
  opacity: 0;
  margin-top: space(-4.75);
}

.squish-leave-to {
  opacity: 0;
  margin-top: space(-4.75);
}

.in-enter-active,
.in-leave-active {
  position: absolute;
  width: 100%;
  transition: all asd20-speed(1) $anim-easing;
}

.in-enter {
  transform: translateX(100vw);
}

.in-leave-to {
  transform: translateX(-100vw);
}

.out-enter-active,
.out-leave-active {
  position: absolute;
  width: 100%;
  transition: all asd20-speed(1) $anim-easing;
}
.out-enter {
  transform: translateX(-100vw);
}
.out-leave-to {
  transform: translateX(100vw);
}
</style>
